import React, { ReactNode } from "react";
import { Box, Card, CardContent, Typography } from "@material-ui/core";

interface Props {
  icon: ReactNode;
  title: string;
  children: ReactNode;
}

export const UserSectionCard = ({ icon, title, children }: Props) => {
  return (
    <Card style={{ minHeight: "100%" }}>
      <CardContent>
        <Box display={"flex"} alignItems={"center"}>
          {icon}
          <Box flexGrow={1} pl={2}>
            <Typography variant={"h6"} color={"textSecondary"}>
              {title}
            </Typography>
          </Box>
        </Box>
        {children}
      </CardContent>
    </Card>
  );
};
